// @flow

import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

type StorylineQueryProps = {
  storyline: PropTypes.any.isRequired,
  loading: PropTypes.bool,
};

const query = gql`
  query storyline {
    storylineGraphql1View {
      entityLabel
      fieldSubtitle
      fieldThemeColor
      fieldFile
      entityUrl {
        alias
      }
    }
  }
`;

const withQuery = graphql(query, {
  props: ({
    data: { storylineGraphql1View, loading },
  }: any): StorylineQueryProps => ({
    storyline: storylineGraphql1View,
    loading,
  }),
});

export default withQuery;



// WEBPACK FOOTER //
// ./screens/App/components/Wheel/StorylineQuery.js